module.exports = __webpack_public_path__ + "img/Ib.dc748a73.png";